import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';

import styles from './PlanningDashboardTourModal.module.less';

const PlanningDashboardTourModal = ({ onInitTour, closeModal }) => {
  const startTour = () => {
    onInitTour();
    closeModal();
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Welcome to your <br /> planning dashboard!
      </div>
      <p className={styles.subtitle}>
        We’ll guide you through all your <br /> wedding planning, all right here.
      </p>
      <ButtonV2 onClick={startTour}>Let&apos;s Do This</ButtonV2>
    </div>
  );
};

export default PlanningDashboardTourModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/PlanningDashboardTourModal/PlanningDashboardTourModal.jsx